import { CommunityChannelApi } from '@ps/api/community-channel';
import { ReportReasonEnumItem } from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * File a report on a channel message. The server logs the report
 * for moderator review — there's no client-side state change
 * (reports don't gate the message itself).
 */
export async function reportChannelMessage({
  creatorId,
  channelId,
  messageId,
  reason,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
  reason: ReportReasonEnumItem;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerAddCommunityChannelMessageReport({
    sellerId: creatorId,
    channelId,
    messageId,
    AddCommunityChannelMessageReportRequest: { reason },
  });
}
